import { put } from "typed-redux-saga";
import { AppConfig } from "../../AppConfig";
import {
  challengePasskeyLoginApi,
  challengePasskeyRegisterApi,
  checkActivationApi,
  checkEmailApi,
  domainBaseURLOption,
  loginApi,
  loginWithPasskeyApi,
  logoutApi,
  registerPasskeyApi,
  resetPasswordApi,
  sendActivationOtpApi,
  sendOtpApi,
  sendEmailOtpApi,
  tokenLoginApi,
  updateCredentialsApi,
  updatePasswordApi,
  verifyApi,
  emailVerifyApi,
} from "../../core/http/httpClient";
import { LocalStorageManager } from "../../core/storage/LocalStorageManager";
import { makeAsyncApiCall } from "../common";
import { takeEveryFsa } from "../operations";
import { authActions } from "./actions";
import { User } from "./types";

export function* authSaga() {
  yield takeEveryFsa(authActions.getLoggedInUser.started, function* (action) {
    const loggedInUser: User | null =
      LocalStorageManager.Instance.getObject(
        AppConfig.Instance.LocalStorageKey["loggedInUser"],
      ) ?? null;

    if (loggedInUser) {
      yield put(
        authActions.getLoggedInUser.done({
          params: {},
          result: loggedInUser,
        }),
      );
    }
  });

  yield takeEveryFsa(authActions.checkUserEmail.started, function* (action) {
    yield* makeAsyncApiCall(action, authActions.checkUserEmail, checkEmailApi);
  });

  yield takeEveryFsa(authActions.loginWithPassword.started, function* (action) {
    yield* makeAsyncApiCall(action, authActions.loginWithPassword, loginApi);
  });

  yield takeEveryFsa(
    authActions.challengePasskeyLogin.started,
    function* (action) {
      yield* makeAsyncApiCall(
        action,
        authActions.challengePasskeyLogin,
        challengePasskeyLoginApi,
      );
    },
  );

  yield takeEveryFsa(
    authActions.challengePasskeyRegister.started,
    function* (action) {
      yield* makeAsyncApiCall(
        action,
        authActions.challengePasskeyRegister,
        challengePasskeyRegisterApi,
      );
    },
  );

  yield takeEveryFsa(authActions.loginWithPasskey.started, function* (action) {
    yield* makeAsyncApiCall(
      action,
      authActions.loginWithPasskey,
      loginWithPasskeyApi,
      domainBaseURLOption(),
    );
  });

  yield takeEveryFsa(authActions.registerPasskey.started, function* (action) {
    yield* makeAsyncApiCall(
      action,
      authActions.registerPasskey,
      registerPasskeyApi,
    );
  });

  yield takeEveryFsa(
    authActions.sendActivationOtpToPhoneNumber.started,
    function* (action) {
      yield* makeAsyncApiCall(
        action,
        authActions.sendActivationOtpToPhoneNumber,
        sendActivationOtpApi,
      );
    },
  );

  yield takeEveryFsa(
    authActions.sendOtpToPhoneNumber.started,
    function* (action) {
      yield* makeAsyncApiCall(
        action,
        authActions.sendOtpToPhoneNumber,
        sendOtpApi,
      );
    },
  );

  yield takeEveryFsa(
    authActions.sendOtpToEmail.started,
    function* (action) {
      yield* makeAsyncApiCall(
        action,
        authActions.sendOtpToEmail,
        sendEmailOtpApi,
      );
    },
  );

  yield takeEveryFsa(
    authActions.sendResetPasswordEmail.started,
    function* (action) {
      yield* makeAsyncApiCall(
        action,
        authActions.sendResetPasswordEmail,
        resetPasswordApi,
      );
    },
  );

  yield takeEveryFsa(authActions.updatePassword.started, function* (action) {
    yield* makeAsyncApiCall(
      action,
      authActions.updatePassword,
      updatePasswordApi,
    );
  });

  yield takeEveryFsa(
    authActions.updateLoginCredentials.started,
    function* (action) {
      yield* makeAsyncApiCall(
        action,
        authActions.updateLoginCredentials,
        updateCredentialsApi,
      );
    },
  );

  yield takeEveryFsa(
    authActions.checkActivationToken.started,
    function* (action) {
      yield* makeAsyncApiCall(
        action,
        authActions.checkActivationToken,
        checkActivationApi,
      );
    },
  );

  yield takeEveryFsa(authActions.verifyPhoneNumber.started, function* (action) {
    yield* makeAsyncApiCall(
      action,
      authActions.verifyPhoneNumber,
      verifyApi,
      domainBaseURLOption(),
    );
  });

  yield takeEveryFsa(authActions.verifyEmail.started, function* (action) {
    yield* makeAsyncApiCall(
      action,
      authActions.verifyEmail,
      emailVerifyApi,
      domainBaseURLOption(),
    );
  });

  yield takeEveryFsa(authActions.tokenLogin.started, function* (action) {
    yield* makeAsyncApiCall(
      action,
      authActions.tokenLogin,
      tokenLoginApi,
      domainBaseURLOption(),
    );
  });

  yield takeEveryFsa(authActions.logout.started, function* (action) {
    yield* makeAsyncApiCall(action, authActions.logout, logoutApi);
  });
}
